import { WithStyles } from '@mui/styles';
import { IPatient } from 'interfaces/redux/IPatient';
import { IMedicationListItem } from 'interfaces/redux/IMedications';
import { styles } from '../patient-clinical-styles';

export enum MedicationListOrigin {
  DUR,
  MEDICATION_LIST,
}
export interface IProps extends WithStyles<typeof styles> {
  isLoading: boolean;
  patient: IPatient;
  showMedicationList: boolean;
  medicationList: IMedicationListItem[];
  overwriteGroups: IMedicationListItem[];
  minimal: boolean;
  options: any;
  readOnly: boolean;
  hideChildren: boolean;
  origin: MedicationListOrigin;
  cancelAddForm: () => void | undefined | null;
  postSave: () => void | undefined | null;
}

export interface IRemoveAllModalProps extends WithStyles<typeof styles> {
  overwriteGroups: IMedicationListItem[];
  patient: IPatient;
  open: boolean;
  onClose: () => void;
}
